import { useMembers } from './use-members'
import { useMemberActions } from './use-member-actions'
import { refreshMembersList } from '../store'
import { useMemberParams } from '../ui/use-member-params'

const useMembersList = () => {
	const { q, status } = useMemberParams()
	const { members } = useMembers(q ?? null, status ?? null)
	const { archiveTeamMember } = useMemberActions()

	const handleArchive = async (id: string): Promise<void> => {
		await archiveTeamMember(id)
		refreshMembersList()
	}

	return { members, handleArchive }
}

export { useMembersList }
